import { ContactInformation as ContactInfoProto } from '@taxfyle/api-internal/shared/types/contact_info_pb'
import type { ContactInfo } from './ContactInfo'
import {
  mapPhysicalAddressToProto,
  mapProtoToPhysicalAddress,
} from '@/features/tax-profile/physical-address-mapper'
import { PhysicalAddress } from '@/features/tax-profile/PhysicalAddress'

export function mapProtoToContactInfo(proto: ContactInfoProto): ContactInfo {
  const addrProto = proto.getAddress()
  return {
    email: proto.getEmail(),
    phoneNumber: proto.getPhoneNumber() ?? '',
    physicalAddress: addrProto
      ? mapProtoToPhysicalAddress(addrProto)
      : PhysicalAddress.empty,
  }
}

export function mapContactInfoToProto(
  contactInfo: ContactInfo,
): ContactInfoProto {
  return new ContactInfoProto()
    .setEmail(contactInfo.email)
    .setPhoneNumber(contactInfo.phoneNumber)
    .setAddress(mapPhysicalAddressToProto(contactInfo.physicalAddress))
}
